//#region IMPORTS
import { promosSelectors } from "../../features/promos/promosSlice";
import { useAppSelector } from "../../store/configureStore";
import { useTranslation } from "react-i18next";
import BasketEmptyPromoItem from "./BasketEmptyPromoItem";
import { Fragment } from "react";
//#endregion

export default function BasketEmpty() {
  //#region SETUP
  // Translation
  const { t } = useTranslation();

  // Redux
  const promos = useAppSelector(promosSelectors.selectAll);
  //#endregion

  //#region RENDER
  return (
    <main className="w-full flex items-center justify-center py-32">
      <div className="mx-auto max-w-full">
        <h2 className="text-2xl font-semibold text-gray-900">
          {t("rituals.yourBasketIsEmpty")}
        </h2>

        {!!promos && promos.length > 0 && (
          <Fragment>
            <p className="mt-1 text-sm text-gray-500">
              {t("rituals.getStartedBySelectingItemsFromABackorderablePromo")}.
            </p>
            <ul className="mt-6 divide-y divide-gray-200 border-t border-b border-gray-200">
              {promos.map((promo) => (
                <BasketEmptyPromoItem promo={promo} key={promo.id} />
              ))}
            </ul>
          </Fragment>
        )}
      </div>
    </main>
  );
  //#endregion
}
